import { useEffect } from "react"
import UMCResult from "../common/UMCResult"
import { clearLocalStorage, clearSession } from "../../utils/SecurityUtils"
import { useNavigate } from "react-router-dom"
import { getSessionItem } from "../../utils/storageUtils"
import { CC_PRODUCT_ID } from "../../utils/Constants"
import { logout } from "../../store/actions/CommonActions"

const Logout = () => {

    const navigate = useNavigate()

    useEffect(() => {

        if(getSessionItem(CC_PRODUCT_ID)) {
            logout(() => {
                clearSession()
                clearLocalStorage()
            })
        } else {
            navigate("/unauthorized")
        }
    }, [])


    return <UMCResult
        subTitle={"MSG_LOGOUT_SUCCESS_MESSAGE"}
        status={200}
    />
}

export default Logout